import React, { Component } from 'react';
import authService from './../api-authorization/AuthorizeService'
import { ConfigMenu } from './../ConfigMenu'
import QRCode from 'react-qrcode-logo';
import generatePDF, { Resolution, Margin } from 'react-to-pdf';

export class ConfigQRcode extends Component {
  constructor(props) {
    super(props);
    var curDate = new Date();
    curDate.setHours(0,0,0,0);
    this.state = {
      profiles: [],
      profile: null,
      loading: true,
      companyId: parseInt(this.props.match.params.companyId) || 0
    };
  }

  componentDidMount() {
    if (this.state.companyId === 0)
      this.populateCompaniesData();
    else
      this.populateProfilesData(this.state.companyId);
  }

  async addHeader(event) {
    var formData = new FormData();
    formData.append("file", event.target.files[0]);

    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/qrheader`, {
      method: 'POST',
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain'
      },
      body: formData
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, company: {...prevState.company, header: data}}));
  }

  async addFooter(event) {
    var formData = new FormData();
    formData.append("file", event.target.files[0]);

    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/qrfooter`, {
      method: 'POST',
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain'
      },
      body: formData
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, company: {...prevState.company, footer: data}}));
  }

  renderProfilesTable() {
    const getTargetElement = () => document.getElementById('toprint');
    const options = {
      // default is `save`
      method: 'open',
      // default is Resolution.MEDIUM = 3, which should be enough, higher values
      // increases the image quality but also the size of the PDF, so be careful
      // using values higher than 10 when having multiple pages generated, it
      // might cause the page to crash or hang.
      resolution: Resolution.HIGH,
      page: {
          // margin is in MM, default is Margin.NONE = 0
          margin: Margin.SMALL,
          // default is 'letter'
          format: 'A4',
          // default is 'landscape'
          orientation: 'portrait',
      },
      canvas: {
          // default is 'image/jpeg' for better size performance
          mimeType: 'image/png',
          qualityRatio: 1
      },
      // Customize any value passed to the jsPDF instance and html2canvas
      // function. You probably will not need this and things can break, 
      // so use with caution.
      /*overrides: {
          // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
          pdf: {
            compress: true
          },
          // see https://html2canvas.hertzen.com/configuration for more options
          canvas: {
            useCORS: true
          }
      },*/
    };
    return (
      <>
        <div style={{marginTop: "10px"}}>
          <label for="image-upload" class="btn btn-primary">
            <i class="fa fa-cloud-upload"></i> Upload header image
          </label>
          <input id="image-upload" onChange={this.addHeader.bind(this)} type="file"/>
        </div>
      <div style={{border: "1px solid #ccc"}}><div id="toprint">
        <div style={{minHeight: "100px", contentAlign: "middle"}} class="main2 qrheaderdiv">Вы — автор своего расписания. Позвольте себе жизнь без ожиданий и неожиданностей.</div>
        <div class="qrheaderdiv main2">Наша система бронирования</div>
        <div class="qrdiv"><QRCode value={`https://www.planna.ru/booking/${this.state.companyId}`} size={330} qrStyle='fluid' logoPadding={10} removeQrCodeBehindLogo eyeRadius={15} ecLevel='H' logoImage='/plannasm.png' logoWidth={80} logoHeight={80}></QRCode></div>
        <div style={{marginTop: "15px", minHeight: "100px"}} class="main4 qrheaderdiv">Ваше время бесценно. Тратьте его на жизнь, а не на планирование.</div>
      </div></div>

        <div class="tablediv">
          <label for="image-upload" class="btn btn-primary">
            <i class="fa fa-cloud-upload"></i> Upload footer image
          </label>
          <input id="image-upload" onChange={this.addFooter.bind(this)} type="file"/>
        </div>

      <div style={{marginTop: "20px"}}>
        <label for="Button_Pdf">To print the contents of the page </label>
        <input style={{marginLeft: "5px"}} class="btn btn-primary" type="button" value="Create PDF" id="Button_Pdf" onClick={() => generatePDF(getTargetElement, options)}/>
      </div>
      </>
    );
  }

  render() {
    let contents = this.state.loading
      ? <p><em>Loading...</em></p>
      : this.renderProfilesTable();

    return (
      <div class="sidenav-container-div">
        <ConfigMenu {...this.props} companyId={this.state.companyId} selected="qrcode" />
        <h4 id="tabelLabel">QR-code generation</h4>
        <div>Page with QR-code</div>
        {contents}
      </div>
    );
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (this.state.companies.length > 0)
    {
        this.setState(prevState => ({...prevState, company: this.state.companies[0], companyId: this.state.companies[0].id}));
        this.populateProfilesData(this.state.companyId);
    }
  }

  async populateProfilesData(companyId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/profiles`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, profiles: data, loading: false}));
  }
}
